import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga'
import { Route } from 'react-router-dom'

class GoogleAnalytics extends Component {
  componentDidMount() {
    const {
      location: { pathname, search },
    } = this.props
    this.logPageChange(pathname, search)
  }

  componentDidUpdate({ location: prevLocation }) {
    const {
      location: { pathname, search }
    } = this.props
    const isDifferentPathname = pathname !== prevLocation.pathname
    const isDifferentSearch = search !== prevLocation.search

    if (isDifferentPathname || isDifferentSearch) {
      this.logPageChange(pathname, search)
    }
  }

  logPageChange(pathname, search = '') {
    const page = pathname + search
    const { location } = window
    const { options } = this.props
    ReactGA.set({
      page,
      location: `${location.origin}${page}`,
      ...options,
    })
    ReactGA.pageview(page)
  }

  render() {
    return null
  }
}

const RouteTracker = () => <Route component={GoogleAnalytics} />

const init = (options = {}) => {
  const isGAEnabled = process.env.NODE_ENV === 'production'

  if (isGAEnabled) {
    ReactGA.initialize('UA-60525736-5')
  }
  return isGAEnabled
}

export default {
  GoogleAnalytics,
  RouteTracker,
  init,
}

GoogleAnalytics.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  options: PropTypes.object,
}
